<template>
  <!--页面顶部导航栏-->
  <div class="wrapper">
    <!--登录模块-->
    <div class="cover" v-if="showLogin">
      <div class="loginWrap">
        <el-button class="close" icon="el-icon-close" @click="showLogin=false"></el-button>
        <div class="login-img-wrap">
          <img style="width:171px;height:68px;" src="../assets/image/login-img.png" alt>
        </div>
        <div>
          <el-input
            style="width:510px;margin-left:48px;margin-top:40px;margin-bottom:24px;"
            placeholder="请输入您的手机号"
            v-model="from.tel"
            clearable
          ></el-input>
        </div>

        <div class="auth-wrap">
          <el-input
            style="width:510px;margin-left:48px;"
            placeholder="请输入密码"
            v-model="from.password"
            show-password
            clearable
          ></el-input>
        </div>
        <div class="password-wrap">
          <router-link :to="{path:'PersonCenter',query:{active:3}}">
            <div class="findPassword">找回密码</div>
          </router-link>
          <router-link :to="{path:'PersonCenter',query:{active:4}}">
            <div class="change-Password">修改密码</div>
          </router-link>
        </div>

        <el-button
          style="background: #23457b; width:510px;margin-top:40px;margin-left:45px;"
          type="success"
          @click="login()"
        >登录</el-button>
        <div class="login-wrap">
          <div class="login-btn" @click="showLogin=false,showSign=true">没有账号,去注册</div>
        </div>
      </div>
    </div>

    <!--注册模块-->
    <div class="cover" v-if="showSign">
      <div class="loginWrap">
        <el-button class="close" icon="el-icon-close" @click="showSign=false"></el-button>
        <div class="login-img-wrap">
          <img style="width:171px;height:68px;" src="../assets/image/login-img.png" alt>
        </div>
        <el-input
          style="width:510px;margin-top:40px;margin-left:48px;margin-bottom:12px;"
          placeholder="请输入您的手机号"
          v-model="SignIn.mobile"
          clearable
        ></el-input>
        <el-input
          style="width:510px;margin-left:48px;margin-bottom:12px;"
          placeholder="输入您的密码"
          v-model="SignIn.password"
          show-password
          clearable
        ></el-input>
        <el-input
          style="width:510px;margin-left:48px;margin-bottom:12px;"
          placeholder="确认密码"
          v-model="SignIn.re_password"
          show-password
          clearable
        ></el-input>
        <div class="auth-wrap">
          <el-input
            style="width:400px;margin-left:48px;"
            placeholder="请输入您的验证码"
            v-model="authCode"
            clearable
          ></el-input>
          <CodeBtn :mobile="SignIn.mobile" :url="codeUrl"></CodeBtn>
        </div>

        <el-button
          style="background: #23457b; width:510px;margin-top:26px;margin-left:45px;"
          type="success"
          @click="signInClick()"
        >完成注册</el-button>
        <div class="signIn-wrap">
          <div class="signIn-btn" @click="showLogin=true,showSign=false">已有账号,去登录</div>
        </div>
      </div>
    </div>

    <!--广告位置-->
    <header class="tophead">
      <img class="headimgA" :src="logo" @click="$router.push('/')">

      <a :href="dingbu1.dirlink" v-if="dingbu1.type&&dingbu1.type===1">
        <object data type style="width: 958px;height: 80px;display: block">
          <embed
            class="headimgB"
            :src="dingbu1.logo"
            allowscriptaccess="always"
            allowfullscreen="true"
            wmode="opaque"
            type="application/x-shockwave-flash"
            quality="high"
          >
        </object>
      </a>
      <a :href="dingbu1.dirlink" v-else>
        <img class="headimgB" :src="dingbu1.logo">
      </a>
    </header>
    <nav class="navA">
      <div class="nav-wrap">
        <ul class="navbar-1">
          <router-link class="navList" to="/" tag="li">首页</router-link>
          <router-link
            class="navList"
            tag="li"
            :to="{path:'/ComplainView',query:{id:'1',title:'投诉榜'}}"
          >投诉榜</router-link>
          <router-link
            class="navList"
            tag="li"
            :to="{path:'/ComplainView',query:{id:'3',title:'评论榜',}}"
          >评论榜</router-link>
          <router-link
            class="navList"
            tag="li"
            :to="{path:'/ComplainView',query:{id:'2',title:'和解榜'}}"
          >和解榜</router-link>
        </ul>
        <ul class="navbar-2">
          <router-link
            class="navList"
            v-for="(item,index) in Category"
            v-text="item.name"
            :key="index"
            :to="{path:'/HeaderNewsList',query:{id:item.id}}"
            v-on:click.native="activeSkip"
          ></router-link>
        </ul>
        <div class="sign">
          <span class="date">{{time}}</span>
          <div class="sign-wrap" v-if="successLogin">
            <button class="signUp" @click="showLoginWrap">登录</button>
            <button class="signIn" @click="showSign=true ">注册</button>
          </div>
          <div v-else>
            <el-dropdown placement="bottom">
              <div class="head-photo" type="primary">
                <img
                  class="img-wrap"
                  v-if="!memberMsg"
                  src="../assets/image/head_photo.svg"
                  alt
                  @click="showMenu"
                >
                <img class="img-wrap" v-if="memberMsg" :src="memberMsg" alt @click="showMenu">
              </div>
              <el-dropdown-menu class="menu-wrap" slot="dropdown">
                <el-dropdown-item>
                  <router-link to="/PersonCenter">个人中心</router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link to="/ComplainCenter">投诉和消息中心</router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="logOut">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </nav>

    <!--16个新闻分类导航-->
    <div class="navB-wrap" v-if="false">
      <nav class="navB">
        <ul class="navbar">
          <router-link
            class="navList"
            v-for="(item,index) in Category"
            v-text="item.name"
            :key="index"
            :to="{path:'/HeaderNewsList',query:{id:item.id}}"
            v-on:click.native="activeSkip"
          ></router-link>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import CodeBtn from "@/components/CodeBtn.vue";

export default {
  name: "Header",
  props: {
    msg: String
  },
  components: {
    CodeBtn
  },
  data() {
    return {
      menu: false,
      imgsrc: "../assets/logo.png",
      Category: {},
      showLogin: false,
      logo: "",
      dingbu1: "",
      from: {
        tel: "",
        password: ""
      },
      SignIn: {
        mobile: "",
        msg_code: "",
        password: "",
        re_password: "",
        report_id: 0
      },
      authCode: "", // 短消息验证码
      codeUrl: this.ServicesApi.send_msg_code,
      registerToken: "",
      successLogin: true,
      time: "",
      memberMsg: "",
      adTop: "",
      showSign: false
    };
  },
  created() {
    this.getArticle();
    this.examine();
    this.getTime();
    this.getMember();
    this.getGuangGao();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },

  methods: {
    getArticle() {
      this.$get("/index/index/article")
        .then(res => {
          if (res.code === 0) {
            this.Category = res.data.category.reverse();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getMember() {
      let token = localStorage.getItem("token");
      this.$post(this.ServicesApi.member_info, {
        token: token
      })
        .then(res => {
          if (res.code === 0) {
            this.memberMsg = res.data.headimg;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    activeSkip() {
      this.$emit("callFather");
    },

    goNewsList() {
      this.$router.push("article");
    },
    showLoginWrap() {
      this.showLogin = true;
    },
    showMenu() {
      this.menu = !this.menu;
    },
    //获取时间

    getTime() {
      let myDate = new Date();
      let timeA = myDate.getFullYear();
      let timeB = myDate.getMonth() + 1;
      let timeC = myDate.getDate();
      this.time = timeA + "年" + timeB + "月" + timeC + "日";
    },
    //登录
    login() {
      let params = { mobile: this.from.tel, password: this.from.password };
      if (localStorage.getItem("report_id")) {
        params.report_id = localStorage.getItem("report_id");
      }
      this.$post(this.ServicesApi.loginin, params)
        .then(res => {
          if (res.code === 0) {
            this.registerToken = res.data.token;
            localStorage.setItem("token", this.registerToken);
            this.showLogin = false;
            this.successLogin = false; //是否显示登录按钮
            location.reload();
          } else if (res.code !== 0) {
            this.$message(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 注册函数
    signInClick() {
      let params = {
        mobile: this.SignIn.mobile,
        msg_code: this.authCode,
        password: this.SignIn.password,
        re_password: this.SignIn.re_password
      };
      if (localStorage.getItem("report_id")) {
        params.report_id = localStorage.getItem("report_id");
      }
      this.$post(this.ServicesApi.register, params)
        .then(res => {
          if (res.code === 0) {
            this.$message("注册成功，请去登录");
            this.showSign = false;
          } else if (res.code !== 0) {
            this.$message(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    logOut() {
      localStorage.removeItem("token");
      location.reload();
      this.$router.push("/");
    },
    //加载时检查token是否存在
    examine() {
      let msg = localStorage.getItem("token");
      console.log(msg);
      if (msg) {
        this.showLogin = false;
        this.successLogin = false; //是否显示登录按钮
      } else {
        msg = "";
      }
    },

    //获取广告
    getGuangGao() {
      this.$get(this.ServicesApi.ad_position)
        .then(res => {
          if (res.code === 0) {
            this.logo = res.data.logo;
            console.log(res.data, "这是网站logo");
            this.dingbu1 = res.data.ad_top;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@img: red;
.wrapper {
  width: 100%;
  height: 100%;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-demo {
  border-radius: 55%;
}

.menu-wrap {
  text-align: center;
}

.home-page {
  // height: 21px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  cursor: pointer;
  text-align: center;
}

.tophead {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  padding: 16px;
  display: flex;

  .headimgA {
    width: 201px;
    height: 80px;
  }

  .headimgB {
    width: 958px;
    height: 80px;
    margin-left: 50px;
  }
}

.navA {
  width: 100%;
  background: #294b7f;

  .nav-wrap {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 1200px;
  }

  .navbar-1 {
    height: 50px;
    width: 275px;
    display: flex;
    justify-content: space-around;
  }

  /*.navList:nth-child(1) {*/
  /*margin-left: 363px;*/
  /*}*/

  .navList {
    // height: 21px;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    line-height: 50px;
    cursor: pointer;
    text-align: center;
  }
  .navbar-2{
    .navList{
      padding: 0 20px;
    }
  }

  .menu {
    position: absolute;
    width: 125px;
    height: 136px;
    background: #ffffff;
    text-align: center;
    left: -42px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.75);

    p {
      margin: 0;
      padding: 0;
      height: 32px;
      line-height: 32px;
      margin: 6px 0;
    }

    p:hover {
      background: #f3f3f3;
      cursor: pointer;
    }
  }

  .sign {
    display: flex;
    align-items: center;

    .date {
      height: 19px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 19px;
      margin: 10px 0;
      display: inline-block;
      margin-right: 20px;
    }

    .sign-wrap {
      display: inline;
      margin-left: 20px;
    }

    .head-photo {
      width: 39px;
      height: 39px;
      cursor: pointer;
    }

    .img-wrap {
      width: 39px;
      height: 39px;
      border-radius: 50%;
    }

    .signUp,
    .signIn {
      width: 80px;
      height: 30px;
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
      background: #d1ab73;
      margin-left: 16px;
      margin: 10px 0;
    }

    .signIn {
      background: #294b7f;
      color: #ebd35a;
      border: 1px solid #d1ab73;
      margin-left: 10px;
    }
  }
}

.navB-wrap {
  width: 100%;
  margin: 0 auto;
  background: #f3f3f3;
}

.navB {
  display: flex;
  min-width: 1200px;

  .navbar {
    display: flex;
    height: 50px;
    margin: 0 auto;
    min-width: 1200px;
    justify-content: space-between;
  }

  .navList {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 50px;
    margin-bottom: 40px;
  }
}

.cover {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}

.loginWrap {
  width: 600px;
  height: 456px;
  margin: 0 auto;
  margin-top: 120px;
  position: relative;
  background: #ffffff;
  border-radius: 0.5%;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}

.login-img-wrap {
  height: 115px;
}

.login-img-wrap > img {
  margin-left: 215px;
  margin-top: 48px;
  margin-bottom: 40px;
}

.phone-wrap {
  width: 510px;
  height: 48px;
}

.auth-wrap {
  display: flex;
}

.clickAuth {
  font-size: 16px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  line-height: 21px;
}

.close {
  position: absolute;
  right: 8px;
  top: 8px;
  background: #23457b;
  color: white;
  border-radius: 12px;
  line-height: 20px;
  text-align: center;
  /*height: 20px;*/
  /*width: 20px;*/
  font-size: 18px;
  border: none;
  padding: 1px;
  cursor: pointer;
}

.password-wrap {
  display: flex;
  justify-content: space-between;
}

.findPassword {
  font-size: 15px;
  margin-top: 10px;
  color: #294b7f;
  margin-left: 50px;
}

.change-Password {
  margin-right: 45px;
  font-size: 15px;
  margin-top: 10px;
  color: #294b7f;
}

.signIn-wrap,
.login-wrap {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: center;

  .signIn-btn,
  .login-btn {
    cursor: pointer;
  }
}
</style>
